var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle204(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "206.95931069001153 682.5999859780496 31.57137605369695 31.600027991701722",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M234.53,698.17c.07,6.68-5.22,12.04-11.9,12.03-6.52,0-11.6-5.04-11.67-11.57-.07-6.7,5.2-12.04,11.89-12.03,6.52,0,11.61,5.04,11.68,11.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle204);
export default __webpack_public_path__ + "static/media/twinkle-2-04.dc84791e2a11dad2589fd412a0ca22b1.svg";
export { ForwardRef as ReactComponent };